import type {RouteLocationNormalized} from 'vue-router';

export const SITE_NAME = 'Community Coaching';

/**
 * Setzt Titel, Canonical und og:url für die aktuelle Route.
 *
 * Die Basis-URL kommt bewusst aus `window.location.origin` statt aus einer
 * Konstante: die Plattform läuft White-Label unter eigenen Mandanten-Domains.
 * Ein fest verdrahteter Canonical auf community-coaching.com würde jeder
 * Mandanten-Seite mitteilen, ihr kanonischer Ort liege auf einer fremden
 * Domain — sie fiele damit praktisch aus dem Index.
 *
 * Reichweite: Das greift für Google, das JavaScript rendert. Social-Crawler
 * (Facebook, LinkedIn, WhatsApp, Slack) tun das nicht und sehen weiterhin die
 * Defaults aus dem index.html. Mandantengenaue Vorschauen beim Teilen brauchen
 * serverseitiges Rendering je Domain.
 */
const setLink = (rel: string, href: string): void => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const setMeta = (property: string, content: string): void => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export const applyRouteSeo = (to: RouteLocationNormalized): void => {
  const title = to.meta?.title as string | undefined;

  // Ohne Fallback stand hier bei fehlendem meta.title " - Community Coaching"
  // im Tab, also mit führendem Bindestrich.
  document.title = title ? `${title} - ${SITE_NAME}` : SITE_NAME;

  // Nur öffentliche Seiten bekommen einen Canonical. Alles hinter dem Login
  // gehört ohnehin nicht in den Index.
  const isPublic = to.meta?.noAuthRequired === true;
  if (!isPublic) {
    document.head.querySelector('link[rel="canonical"]')?.remove();
    return;
  }

  const url = `${window.location.origin}${to.path}`;
  setLink('canonical', url);
  setMeta('og:url', url);
};
